import axiosHttp from "./interceptor";

export const getEUETS = (reportMstId) => {
	try {
		const response = axiosHttp.get(
			`api/Report/GetEuEts?reportMstId=${reportMstId}`
		);
		return response;
	} catch (error) {
		console.error("error", error.message);
	}
};

export const getCIIVoyageData = async (masterId) => {
	try {
		const response = await axiosHttp.get(
			`api/Cii/CiiVoyageData?reportMstId=${masterId}`
		);
		return response.data;
	} catch (error) {
		console.error(error.message);
	}
};
